import { dollars, StatusData } from '@oneethos/shared'
import { DocusignEnvelopes } from './docusign-envelopes'
import LoanSummary from './loan-summary'
import { PaymentDetails } from './payment-details'
import ChangeOrders from './change-orders'
import { LoanNumber } from './loan-number'
import { useAppState } from '../hooks'

type ProjectLoanDetailsProps = {
  project: StatusData
  onChange: (project: StatusData) => void
}

export const ProjectLoanDetails = ({ project, onChange }: ProjectLoanDetailsProps) => {
  const { registration: { installer } } = useAppState()

  const loanComponents = () => {
    return (
      <>
        <div className="col-4">
          <PaymentDetails project={project} />
        </div>
        <div className="col-4">
          <LoanNumber project={project} onChange={onChange} />
          <DocusignEnvelopes project={project} onChange={onChange} />
        </div>
      </>
    )
  }

  const loanSummary = () => {
    return (
      <div className="col-4">
        <h6>Cost Summary</h6>
        <LoanSummary
          formData={{
            ...project,
            loanAmount: dollars(project.loanAmount),
          }}
          incentive={project.incentive}
        />
      </div>
    )
  }

  return (
    <div className="row">
      {loanSummary()}
      {(installer.isSupport) && loanComponents()}
      <div className="col-12 mt-4">
        <ChangeOrders projectId={project.id} />
      </div>
    </div>
  )
}

export default ProjectLoanDetails